import React from 'react';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';

import { TimeZoneCrossOverCalculator } from 'views';

export const App = () => {
  return (
    <>
      <HubspotProvider>
        <TimeZoneCrossOverCalculator />
      </HubspotProvider>
    </>
  );
};
